
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[category]/[slug]",
      function () {
        return require("private-next-pages/blog/[category]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[category]/[slug]"])
      });
    }
  